module.exports = __webpack_public_path__ + "static/img/banner.1c0847d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SharePrinting/banner.png
// module id = 39R0
// module chunks = 10